export default __webpack_public_path__ + "static/media/camera-btn-icon.ae714ee3.svg";